export function numberFormatted(n: number = 0, minimumFractionDigits: number = 0){
  return n.toLocaleString(
    undefined, // use a string like 'en-US' to override browser locale
    { minimumFractionDigits }
  );
}